import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';
import { authReducer, AuthState, authStorageSync } from './auth';
import { AuditsState, auditsReducer } from './audits';
import { headerReducer, HeaderState, headerStorageSync } from './header/header.reducer';
import { ReportPageState, reportPageReducer } from './report';
import { anonymousReportReducer, AnonymousReportState } from './anonymous-report/anonymous-report.reducer';
import { UiState, uiReducer } from './ui';
import { ImageBrowserState, imageBrowserReducer } from './image-browser';
import { CustomerSchedulingState, customerSchedulingReducer } from './customer-scheduling';

export interface State {
  router: RouterReducerState;
  auth: AuthState;
  audits: AuditsState;
  header: HeaderState;
  report: ReportPageState;
  anonymousReport: AnonymousReportState;
  ui: UiState;
  imageBrowser: ImageBrowserState;
  customerScheduling: CustomerSchedulingState;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
  auth: authReducer,
  audits: auditsReducer,
  header: headerReducer,
  report: reportPageReducer,
  anonymousReport: anonymousReportReducer,
  ui: uiReducer,
  imageBrowser: imageBrowserReducer,
  customerScheduling: customerSchedulingReducer,
};

const sharedMetaReducers = [authStorageSync, headerStorageSync];

export const metaReducers: MetaReducer<State>[] = !environment.production ? [...sharedMetaReducers] : [...sharedMetaReducers];
